export default "__VITE_ASSET__CbMDGsJ1__"